module.exports = __webpack_public_path__ + "static/media/maksym.256c9aeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DynamicContent/About/peopleCompany/maksym.png
// module id = 749
// module chunks = 0